import { client } from '../http';

export default {
  async setCustomerActivity(activity) {
    return await client.post('/api/customer-activity', { activity });
  },
};



// WEBPACK FOOTER //
// ./src/api/CustomerActivityApi.js